import { render, staticRenderFns } from "./Submarine.vue?vue&type=template&id=e535ae9a&lang=pug&"
import script from "./Submarine.vue?vue&type=script&lang=js&"
export * from "./Submarine.vue?vue&type=script&lang=js&"
import style0 from "./Submarine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports